import './system-reports.scss'
import { useTitle } from "../../../contexts/title";
import { useEffect } from "react";
import SystemReportSearch from "../../../features/common/system-reports-form/components/SystemReportSearch";
import { Box, Item } from "devextreme-react/box";
import CustomReportForm from "../../../features/common/custom-reports-form/components/CustomReportForm";

export default function SystemReportsPage() {

    const pageTitle = useTitle();
    useEffect(() => {
        pageTitle.setTitle('Reports')
    }, [pageTitle]);

    return (
        <div className={'content-block report-page'}>
            <Box>
                <Item ratio={1}>
                    <SystemReportSearch />
                </Item>
                <Item ratio={1}>
                    <CustomReportForm />
                </Item>
            </Box>
        </div>
    )
}
